import { Controller } from "stimulus"

// Loads a tab panel's content from a URL when its associated radio
// becomes the checked one. Fetches once, caches in-place after the
// first activation. The radio lives in a different part of the DOM
// from the panel, so we look it up by id via the radio-id value.
//
// The fetched HTML is injected into the `content` target so the
// surrounding tab footer (Back link, primary action button) is
// preserved.
export default class extends Controller {
  static values = { url: String, radioId: String }
  static targets = ["content"]

  connect() {
    this.loaded = false
    this.radio = document.getElementById(this.radioIdValue)
    if (!this.radio) return

    if (this.radio.checked) this.load()
    this.boundOnChange = () => { if (this.radio.checked) this.load() }
    this.radio.addEventListener("change", this.boundOnChange)
  }

  disconnect() {
    if (this.radio && this.boundOnChange) {
      this.radio.removeEventListener("change", this.boundOnChange)
    }
  }

  async load() {
    if (this.loaded) return
    this.loaded = true

    try {
      const response = await fetch(this.urlValue, {
        headers: { "Accept": "text/html" },
        credentials: "same-origin"
      })
      if (response.ok) {
        this.contentTarget.innerHTML = await response.text()
      } else {
        this.renderError(`HTTP ${response.status}`)
        this.loaded = false
      }
    } catch (e) {
      this.renderError(e.message)
      this.loaded = false
    }
  }

  renderError(reason) {
    this.contentTarget.innerHTML = `<p class="hint">Could not load this tab (${reason}). Reload the page to try again.</p>`
  }
}
